import React from "react";
import localeText from "../../../../../locale";

const DiagnosisStepsSidebar = ({ steps, currentStep, completedSteps, onSelectStep }) => {
  const items = steps.map((step, index) => {
    const stepNumber = index + 1;
    const isActive = currentStep === stepNumber;
    const isCompleted = completedSteps?.has?.(stepNumber);

    return {
      id: stepNumber,
      label: localeText(step.labelKey) || step.fallbackLabel || `Passo ${stepNumber}`,
      isActive,
      isCompleted,
    };
  });

  return (
    <div
      className="border-round-lg p-2 mb-3"
      style={{
        backgroundColor: "var(--theme-background, #fff)",
        border: "1px solid var(--theme-border, #EBEBEB)",
        minWidth: "15rem",
      }}
    >
      <div
        className="text-xs font-semibold uppercase mb-2 p-1"
        style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
      >
        {localeText("businessDiagnosisMenuSelection") || "Menu de seleção"}
      </div>
      <ul className="list-none p-0 m-0 flex flex-column gap-1">
        {items.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              className="w-full text-left border-none cursor-pointer p-2 border-round-md flex align-items-center gap-2 text-sm"
              style={{
                backgroundColor:
                  item.isActive || item.isCompleted
                    ? "color-mix(in srgb, var(--theme-text, #171717) 6%, var(--theme-background, #FFFFFF))"
                    : "transparent",
              }}
              onClick={() => onSelectStep(item.id)}
            >
              <span
                className="flex align-items-center justify-content-center"
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                  color: item.isCompleted
                    ? "var(--theme-primary, #1DAF61)"
                    : "var(--theme-text-muted, #5C5C5C)",
                  flexShrink: 0,
                }}
              >
                {item.isCompleted ? (
                  <i className="pi pi-check" style={{ fontSize: "0.9rem" }} />
                ) : (
                  <i className="pi pi-clock" style={{ fontSize: "0.9rem" }} />
                )}
              </span>
              <span
                style={{
                  color: item.isActive
                    ? "var(--theme-text, #171717)"
                    : "var(--theme-text-muted, #5C5C5C)",
                }}
              >
                {item.label}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DiagnosisStepsSidebar;
